import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import "./fonts/JioType-Medium.ttf";
import { loadingCompleted } from "./utils/call-my-jio";
import * as serviceWorker from "./serviceWorker";
import { isMobile } from "./utils/utils";

import TracerInit from './OpenTelemetry/TracerInit';

//Initialize OpenTelemetry Tracer
const InitializeTracer = async () => {
    await TracerInit();
  };
  
  InitializeTracer();

loadingCompleted();

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// Following code from: https://github.com/facebook/create-react-app/issues/5316#issuecomment-591075209
if (!isMobile.iOS) {
    serviceWorker.register({
        onUpdate: async (registration) => {
            // We want to run this code only if we detect a new service worker is
            // waiting to be activated.
            // Details about it: https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle
            if (registration && registration.waiting) {
                await registration.unregister();
                // Once the service worker is unregistered, we can reload the page to let
                // the browser download a fresh copy of our app (invalidating the cache)
                window.location.reload();
            }
        },
    });
}
